import React, { useEffect, useState } from 'react'
import { MdViewQuilt, MdVideocam, MdSearch, MdFilterList, MdAssistant, MdMicrowave, MdMovie, MdChevronRight, MdOutlineArticle, MdOutlineSentimentSatisfied, MdAmpStories, MdLayers, MdDownload, MdClose, MdCampaign, MdTheaters } from "react-icons/md";
import { FaHighlighter } from "react-icons/fa";
import { BsChatDotsFill } from "react-icons/bs";
import { useNavigate, useParams } from 'react-router-dom';
import { getAccessToken } from '../../../services/authService';
import LoaderSpin from '../../Common/LoaderSpin';
import { toast } from 'react-toastify';
import SaveMenuPopUp from './SaveMenuPopUp';
import ErrorPopUp from '../../Common/ErrorPopUp';
import DeleteMenuPopUp from './DeleteMenu';
import { useDispatch } from 'react-redux';
import { setConnectionErrorOpen } from '../../../store/navSlice';
import SubscriptionModal from '../Editor/sidepanel/SubscriptionModal';
import { fetchRevisions, getSctipStatistics } from './functions';
import { getPlanFeatures, canAccessScreenwriting } from '../../../utils/access';
import { MdOutlineDescription } from "react-icons/md";
import ScriptTitleEditor from '../ScriptTitleEditor';
import PageTitleModal from '../Editor/modals/PageTitleModal';
import PageTitleModalTV from '../Editor/modals/PageTitleModalTV';
import PageTitleModalCommercial from '../Editor/modals/PageTitleModalCommercial';
import { hasTitlePageContent } from '../Editor/utils/titlePageUtils';
import useSubscriptionAccess from '../../../utils/useSubscriptionAccess';

const ScriptOption = ({ title, isDisabled, subtitle, Icon, color, background, onClick, isTreatMentDisabled, openSubscriptionModal }) => {

    return (
        <div onClick={isDisabled ? openSubscriptionModal : isTreatMentDisabled ? () => { } : onClick} className='cursor-pointer flex p-4 border-b justify-between items-center'>
            <div className='flex gap-4'>
                <div className={`rounded-full flex items-center justify-center size-10`} style={{ background: isDisabled || isTreatMentDisabled ? '#F6F6F6' : background }}>
                    <Icon size={24} color={isDisabled || isTreatMentDisabled ? "#AAAAAA" : color} />
                </div>
                <div>
                    <p className='text-[16px] font-medium' style={{ color: isDisabled || isTreatMentDisabled ? '#868686' : '#292929' }}>{title}</p>
                    <p className='text-[13px] font-medium' style={{ color: isDisabled || isTreatMentDisabled ? '#AAAAAA' : '#757575' }}>{subtitle}</p>
                </div>
            </div>
            <MdChevronRight size={24} color={'#CACACA'} />
        </div>
    )
}

const ScriptInfo = () => {
    const { id } = useParams()
    const [loading, setLoading] = useState(1)
    const [scriptData, setScriptData] = useState({})
    const [isSaveOpen, setIsSaveOpen] = useState(false)
    const [isDeleteOpen, setIsDeleteOpen] = useState(false)
    const userData = JSON.parse(localStorage.getItem("user"))
    const planFeatures = getPlanFeatures(userData);
    const subscription = userData.subscription;
    const [revisionLength, setRevisionLength] = useState(0)

    const [users, setUsers] = useState([]);
    const subscriptionAccess=useSubscriptionAccess();
    const [documentWrite, setPermissionToEdit] = useState(false);
    const permissionToEdit=documentWrite && subscriptionAccess.canEdit===true;
    const [isLoading, setIsLoading] = useState(true);
    const [isRevisionLoading, setIsRevisionLoading] = useState(true)
    const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false)
    const [scriptStatistics, setScriptStatistics] = useState({})
    const [isTitlePageOpen, setIsTitlePageOpen] = useState(false)

    const navigate = useNavigate()

    const fetchScript = async () => {
        setLoading(1)
        const token = getAccessToken()
        const url = `${process.env.REACT_APP_DEV_API}/document/${id}`
        try {
            if (!token) {
                throw new Error('A valid session not found')
            }
            const res = await fetch(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            if (!res.ok) {
                throw new Error('Error getting response', res)
            }
            const body = await res.json()
            setScriptData(body.data)
            setScriptStatistics( getSctipStatistics(body.data.content,id))
            setLoading(0);
            const isAdmin = body.data?.userId === userData?._id;
            if (isAdmin) setPermissionToEdit(true);
            else {
                const allowedToEdit = (body.data.invitedCollaborators || []).find(user => (user.userId?._id || user.userId) === userData._id)?.permissions?.SCRIPT === "WRITE";
                setPermissionToEdit(allowedToEdit);
            }

            if (users.length === 0 && planFeatures?.canCollaborate) fetchCollaborator();
            else setIsLoading(false);
        } catch (error) {
            toast.error("Failed to fetch script")
            setLoading(2)
            setIsLoading(false);
            console.error(error)
        }
    }

    const updateRevisionLength = async()=>{
        setIsRevisionLoading(true)
        setRevisionLength(await fetchRevisions(id))
        setIsRevisionLoading(false)
    }

    const { type, title, invitedCollaborators, status, content, scenes } = scriptData

    const scriptType = type === 'FILM' ? 'Film'
        : type === 'TV' ? 'TV'
            : type === 'TREATMENT' ? 'Treatment' :
            type === 'COMMERCIAL' ? 'Commercial' :
                ''
    const ScriptIcon = type === 'FILM' ? MdMovie
        : type === 'TV' ? MdMicrowave
            : type === 'TREATMENT' ? MdAssistant :
            type === 'COMMERCIAL' ? MdCampaign :
                ''

    const fetchCollaborator = async () => {
        setIsLoading(true);
        const token = getAccessToken();
        try {
            const response = await fetch(
                `${process.env.REACT_APP_DEV_API}/documents/${id}/invites`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setIsLoading(false);
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const data = await response.json();
            setUsers(data.data);
        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
        }
    };

  

    const openSubscriptionModal = () => {
        setIsSubscriptionModalOpen(true)
    }

    const isScriptAdmin = scriptData.userId === userData._id

    // Keep collaborator details from the loaded script; the save reply has them unpopulated.
    const mergeSaved = (updated) => {
        setScriptData(prev => ({ ...prev, ...updated, invitedCollaborators: prev.invitedCollaborators }))
    }

    useEffect(() => {
        fetchScript()
        updateRevisionLength()
    }, []);

    return (
        <div className='overflow-y-hidden h-full'>
            <div className='p-4 pb-8 flex justify-between items-center border-b-2'>
                <h1 className='text-[20px] font-bold text-[#292929]'>Scripts</h1>
            </div>
            {loading === 0 && !isLoading && !isRevisionLoading && <div className=' overflow-y-auto h-[calc(100%-5rem)]'>
                <div>
                    <div className='relative p-6 bg-[#F6F6F6]'>
                        <button className='absolute top-4 right-4' onClick={() => { navigate('/home') }}>
                            <MdClose size={28} color='#868686' />
                        </button>
                        <div className=' max-w-[265px] mx-auto'>

                            <div className='mx-auto w-fit h-fit p-4 bg-[#E4E4E4] rounded-lg'>
                                <ScriptIcon size={28} color='#868686' />
                            </div>
                            <ScriptTitleEditor scriptId={id} title={title} canEdit={permissionToEdit} onSaved={mergeSaved}
                                className='mt-3 text-[20px] mx-auto px-1 font-bold text-[#292929] text-center break-all'
                                inputClassName='mt-3 w-full text-[20px]' />
                            <i className='mt-2 block text-center font-thin text-[#757575]'>({scriptType} Script)</i>
                            <div className='mt-6 flex  items-center gap-2'>
                                <button onClick={() => { setIsDeleteOpen(true) }} className='w-[100px] font-medium text-[#AAAAAA]'>
                                    Delete
                                </button>
                                <button onClick={() => { setIsSaveOpen(true) }} className='rounded-full grow text-white text-center font-medium py-[10px] bg-[#D41E79] '>
                                    Save and exit
                                </button>

                            </div>
                        </div>

                    </div>
                    <div>
                        <ScriptOption onClick={() => { navigate(`/editor/${id}`) }} title={'Screenwriting'} subtitle={'Write your script.'}
                            Icon={MdOutlineArticle} color={'#292929'} background={'#F6F6F6'} isDisabled={!canAccessScreenwriting(userData)} openSubscriptionModal={openSubscriptionModal} />

                        {type !== 'TREATMENT' && permissionToEdit && (
                            <ScriptOption onClick={() => { setIsTitlePageOpen(true) }} title={'Title Page'}
                                subtitle={hasTitlePageContent(scriptData) ? 'Edit your title page.' : 'Optional — add a title page.'}
                                Icon={MdOutlineDescription} color={'#0099FF'} background={'#EEF7FF'} />
                        )}

                        <ScriptOption onClick={() => { navigate(`/scripts/${id}/scenes/`) }} title={'Scenes'} subtitle={`${!scriptStatistics.scenes ? 'No' : scriptStatistics.scenes} Scenes`}
                            Icon={MdMovie} isTreatMentDisabled={scriptData.type === "TREATMENT"} color={'#CC8C14'} background={'#FDF8EE'} isDisabled={!planFeatures?.canListScenes} openSubscriptionModal={openSubscriptionModal} />

                        <ScriptOption onClick={() => { navigate(`/scripts/${id}/characters/`) }} title={'Characters'} subtitle={`${!scriptStatistics.characters ? 'No' : scriptStatistics.characters} Characters`}
                            Icon={MdOutlineSentimentSatisfied} isTreatMentDisabled={scriptData.type === "TREATMENT"} color={'#48A966'} background={'#F2FFF6'} isDisabled={!planFeatures?.canUseCharacterBreakdown} openSubscriptionModal={openSubscriptionModal} />

                        <ScriptOption title={'Scene Cards'} subtitle={'Organize Scenes'}
                            Icon={MdAmpStories} onClick={() => { navigate(`/scripts/${id}/scenecards/`) }} isTreatMentDisabled={scriptData.type === "TREATMENT"} color={'#D41E79'} background={'#FFF5FA'} isDisabled={!planFeatures?.canUseSceneBreakdown} openSubscriptionModal={openSubscriptionModal} />

                        <ScriptOption onClick={() => navigate(`/editor/${id}`, { state: { media: 'storyboard' } })} title={'Storyboard'} subtitle={'Saved storyboards and scene generation'} Icon={MdViewQuilt} color={'#0099FF'} background={'#EAF6FF'} />
                        <ScriptOption onClick={() => navigate(`/editor/${id}`, { state: { media: 'video' } })} title={'AI Video'} subtitle={'AI Video and Premium Video'} Icon={MdVideocam} color={'#48A966'} background={'#F2FFF6'} />

                        <ScriptOption onClick={() => { navigate(`/editor/${id}`, { state: { production: true } }) }} title={'Production'} subtitle={'Manage production elements'}
                            Icon={MdTheaters} isTreatMentDisabled={scriptData.type === "TREATMENT"} color={'#CC8C14'} background={'#FDF8EE'} isDisabled={!planFeatures?.canUseCategoriesAndElements} openSubscriptionModal={openSubscriptionModal} />

                        <ScriptOption onClick={() => { navigate(`/scripts/${id}/revisions`) }} title={'Revisions'} subtitle={`${!revisionLength ? 'No' : revisionLength} Revisions`}
                            Icon={FaHighlighter} color={'#D41E79'} background={'#FFF5FA'} isDisabled={!planFeatures?.canApplyRevision} openSubscriptionModal={openSubscriptionModal}  isTreatMentDisabled={!isScriptAdmin}/>

                        <ScriptOption onClick={() => { navigate(`/scripts/${id}/notes`) }} title={'Notes'} subtitle={`${!scriptStatistics.notes ? 'No' : scriptStatistics.notes} Notes`}
                            Icon={BsChatDotsFill} color={'#4eac6b'} background={'#f2fff6'} isDisabled={!planFeatures?.canApplyRevision} openSubscriptionModal={openSubscriptionModal} />



                    </div>
                </div>
            </div>}
            {(loading === 1 || isLoading || isRevisionLoading) && <div className='flex justify-center items-center h-[calc(100%-5rem)]'>
                <LoaderSpin size={30} />
            </div>}
            {loading === 2 && <div className='flex flex-col gap-4 justify-center items-center h-[calc(100%-5rem)] px-6 text-center'>
                <p className='text-[#757575]'>This script couldn't be opened. Please try again.</p>
                <button onClick={() => { navigate('/home') }} className='rounded-full text-white font-medium px-6 py-[10px] bg-[#D41E79]'>Back to Dashboard</button>
            </div>}
            {isSaveOpen && <SaveMenuPopUp isSaveOpen={isSaveOpen} setIsSaveOpen={setIsSaveOpen} id={id} scriptData={scriptData} />}
            {isTitlePageOpen && (type === 'COMMERCIAL'
                ? <PageTitleModalCommercial scriptData={scriptData} setIsPageTitleOpen={setIsTitlePageOpen} onSaved={mergeSaved} />
                : type === 'TV'
                ? <PageTitleModalTV scriptData={scriptData} setIsPageTitleOpen={setIsTitlePageOpen} onSaved={mergeSaved} />
                : <PageTitleModal scriptData={scriptData} setIsPageTitleOpen={setIsTitlePageOpen} onSaved={mergeSaved} />)}
            {isDeleteOpen && <DeleteMenuPopUp onDelete={() => { navigate('/home') }} isOpen={isDeleteOpen} setIsOpen={setIsDeleteOpen} id={id} />}
            <SubscriptionModal isSubscriptionModalOpen={isSubscriptionModalOpen} setIsSubscriptionModalOpen={setIsSubscriptionModalOpen} />
        </div>
    )
}

export default ScriptInfo